import { render, staticRenderFns } from "./BtnDescomprometer.vue?vue&type=template&id=ad267b8a"
import script from "./BtnDescomprometer.vue?vue&type=script&lang=js"
export * from "./BtnDescomprometer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports